// SuperChatAI Constants - AI message texts for different modes

export const AI_MESSAGE_TEXTS = {
  planMyDay:
    "✅ Here's your high-priority orders to begin with.\n👇 Select an order to proceed.",
  highPriorityOrders:
    "✅ Here are your high-priority orders that need immediate attention.\n👇 Select an order to proceed.",
  ordersInDataTriage:
    "✅ Here are your orders currently in Data Triage.\n👇 Select an order to proceed.",
  newlyAllocatedOrders:
    "✅ Here are your newly allocated orders.\n👇 Select an order to proceed.",
  mandatoryFieldsJE:
    "✅ Here are orders with mandatory fields for Journal Entry.\n👇 Select an order to proceed.",
  reviewerUS:
    "✅ Here are orders assigned to US reviewers.\n👇 Select an order to proceed.",
};

/**
 * Get AI message text based on mode
 * @param {string} mode - The current mode (planMyDay, highPriorityOrders, etc.)
 * @returns {string} - The AI message text for the mode
 */
export const getAIMessageText = (mode) => {
  return AI_MESSAGE_TEXTS[mode] || AI_MESSAGE_TEXTS.planMyDay;
};
